import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import type { DateRange } from "@/lib/equipment/availability";

interface AvailabilityPeriodFilterProps {
  period: DateRange | null;
  defaultFrom: string;
  onChange: (period: DateRange | null) => void;
}

/** «Ledig i periode»: viser bare utstyr som har minst ett ledig hele perioden (VIB-2919). */
export function AvailabilityPeriodFilter({ period, defaultFrom, onChange }: AvailabilityPeriodFilterProps) {
  if (!period) {
    return (
      <Button variant="outline" size="sm" onClick={() => onChange({ from: defaultFrom, to: defaultFrom })}>
        Ledig i periode
      </Button>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-sm" role="group" aria-label="Ledig i periode">
      <span className="text-muted-foreground">Ledig</span>
      <Input
        type="date"
        value={period.from}
        onChange={(e) => e.target.value && onChange({ from: e.target.value, to: e.target.value > period.to ? e.target.value : period.to })}
        aria-label="Ledig fra"
        className="h-8 w-[9.5rem]"
      />
      <span className="text-muted-foreground">–</span>
      <Input
        type="date"
        value={period.to}
        min={period.from}
        onChange={(e) => e.target.value && onChange({ ...period, to: e.target.value })}
        aria-label="Ledig til"
        className="h-8 w-[9.5rem]"
      />
      <Button variant="ghost" size="sm" onClick={() => onChange(null)}>Nullstill</Button>
    </div>
  );
}
